module.exports = __webpack_public_path__ + "static/media/printMedia.8dd260ca.jpg";